import './OnboardingFinal.scss';
import React from 'react';
import { Button } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { StepOneIcon, StepThreeIcon, StepTwoIcon } from './icons';

export default function OnboardingFinal() {
  const navigate = useNavigate();

  return (
    <div className="container">
      <div className="left-side">
        <div className="left-side-content">
          <h1>Your free 14-day trial of the Advanced subscription is now active. With your trial, you can:</h1>
          <ul>
            <li>Build unlimited Templates</li>
            <li>Securely collect forms from anyone</li>
            <li>Automate your processes with Workflows</li>
            <li>Report on the data you collect</li>
          </ul>
          <Button primary onClick={() => navigate('/', { replace: true })}>
            Explore my account
          </Button>
          <p className="small-text">If you don't subscribe during your trial period, you'll switch to a free Basic plan.</p>
        </div>
      </div>
      <div className="right-side">
        <div className="right-side-content">
          <h1>Start collecting Forms in just three steps:</h1>
          <div className="bullets">
            <div className="grid-container">
              <div className="grid-item">
                <StepOneIcon />
                <StepTwoIcon />
                <StepThreeIcon />
              </div>
              <div className="grid-item">
                <span>Upload your PDF (or start from scratch)</span>
                <span>Add fields to your Template</span>
                <span>Use your Template to fill out Forms</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
